<div mat-dialog-title>
    เหตุผลยกเลิก
    <div style="float: right; margin-top: -5px;">

        <button *ngIf="isRead" mat-icon-button (click)="isEdit()">
            <img src="../../../../assets/edit-w.png" style="width: 15px;">
        </button>
        <button *ngIf="!isRead" mat-icon-button (click)="isEdit()">
            <img src="../../../../assets/visibility.png" style="width: 15px;">
        </button>
        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>

<mat-dialog-content class="mat-typography">
    <div class="container p-3">
        <form [formGroup]="cancelForm">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="form-group">
                        <!-- <label for="note" class="form-label">หมายเหตุ</label> -->
                        <textarea id="note" class="form-control" formControlName="note" rows="5" [readonly]="isRead"></textarea>
                    </div>
                </div>
            </div>
        </form>

        <div class="row justify-content-center py-3">
            <lifedi-btn *ngIf="cancelForm.valid" lable="บันทึก" class="mr-3"
                customStyle="background-color: #060E9F; color: #FFF; width: 100%;" (click)="confirm(cancelForm.value)">
            </lifedi-btn>
            <lifedi-btn *ngIf="!cancelForm.valid" lable="บันทึก" class="mr-3" disabled="true"
                customStyle="background-color: #C4C4C4; color: #FFF; width: 100%;">
            </lifedi-btn>
            <lifedi-btn lable="ยกเลิก" customStyle="background-color: #C4C4C4; color: #FFF; width: 100%;"
                (click)="closeModal()">
            </lifedi-btn>
        </div>
    </div>
</mat-dialog-content>